import {
  AcceptInviteResponse,
  AcceptedCampaignBrandingDto,
  OpenCampaignInvite,
  StatusType,
} from '../models'
import {AssertTypeFn} from './general'
import {
  assertArray,
  assertEnum,
  assertString,
  assertStringOrNull,
} from '../utils'

export const openCampaignInviteNormaliser: AssertTypeFn<OpenCampaignInvite> = (
  obj,
) => ({
  campaignId: assertString(obj.campaignId),
  campaignImage: assertStringOrNull(obj.campaignImage),
  inviteId: assertString(obj.inviteId),
  payerName: assertString(obj.payerName),
})

export const aggregatedCampaignInvitesNormaliser: AssertTypeFn<
  OpenCampaignInvite[]
> = (arr) => assertArray(arr, openCampaignInviteNormaliser)

export const acceptInviteResponseNormaliser: AssertTypeFn<
  AcceptInviteResponse
> = (obj) => ({
  result: assertEnum(obj.result, StatusType),
})

export const acceptedCampaignBrandingDtoNormaliser: AssertTypeFn<
  AcceptedCampaignBrandingDto
> = (obj) => ({
  campaignId: assertStringOrNull(obj.campaignId),
  campaignLogoUrl: assertStringOrNull(obj.campaignLogoUrl),
  campaignIconUrl: assertStringOrNull(obj.campaignIconUrl),
})
